"use strict";
/* eslint-disable @typescript-eslint/no-use-before-define */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKSelectionMenu = void 0;
var React = __importStar(require("react"));
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var common_1 = require("../../common");
var components_1 = require("../../components");
var models_1 = require("../../models");
var SelectionMenu_models_1 = require("./SelectionMenu.models");
var emptySelection = [];
/**
 * SelectionMenu component definition, to be wrapped with forwardRef
 * @internal
 */
var SelectionMenuDefinition = function (props, ref) {
    //#region Default Props
    var defaultProperties = Object.assign({}, {
        emptyTemplate: function () {
            var EmptyTemplate = React.createElement(React.Fragment, null, "No results found.");
            return EmptyTemplate;
        },
        groupTemplate: function (group) {
            var GroupTemplate = (React.createElement(React.Fragment, null, props.groupToString ? props.groupToString(group) : group.groupName));
            return GroupTemplate;
        },
        groupToString: function (group) { return String(group.groupName); },
        itemTemplate: function (item) {
            var ItemTemplate = (React.createElement(React.Fragment, null, props.itemToString ? props.itemToString(item) : String(item)));
            return ItemTemplate;
        },
        itemToString: function (item) { return String(item); },
    }, props);
    var incomingData = defaultProperties.data, emptyTemplate = defaultProperties.emptyTemplate, filterable = defaultProperties.filterable, _a = defaultProperties.filterFunction, filterFunction = _a === void 0 ? function (d, s) {
        return String(d).toLocaleLowerCase().includes(s);
    } : _a, footerTemplate = defaultProperties.footerTemplate, headerTemplate = defaultProperties.headerTemplate, groupSelection = defaultProperties.groupSelection, groupTemplate = defaultProperties.groupTemplate, isOpen = defaultProperties.isOpen, itemTemplate = defaultProperties.itemTemplate, incomingSelection = defaultProperties.selection, onChange = defaultProperties.onChange, onMenuToggle = defaultProperties.onMenuToggle, selectMultiple = defaultProperties.selectMultiple, menuQAProp = defaultProperties["data-qa"], otherProps = __rest(defaultProperties, ["data", "emptyTemplate", "filterable", "filterFunction", "footerTemplate", "headerTemplate", "groupSelection", "groupTemplate", "isOpen", "itemTemplate", "selection", "onChange", "onMenuToggle", "selectMultiple", "data-qa"]);
    //#endregion
    //#region State
    var _b = React.useState(), wrappedData = _b[0], setWrappedData = _b[1];
    var _c = React.useState(incomingSelection !== undefined ? incomingSelection : emptySelection), selection = _c[0], setSelection = _c[1];
    var _d = React.useState([]), menuItems = _d[0], setMenuItems = _d[1];
    var _e = React.useState(wrappedData ? wrappedData.children : []), filteredItems = _e[0], setFilteredItems = _e[1];
    //#endregion
    //#region Refs
    var menuRef = React.useRef(null);
    React.useImperativeHandle(ref, function () {
        var menu = menuRef.current;
        if (!menu) {
            return {};
        }
        return {
            keyboardController: menu.keyboardController,
            close: function () { return menu.close(); },
            first: function () { return menu.first(); },
            focus: function () { return menu.focus(); },
            last: function () { return menu.last(); },
            next: function () { return menu.next(); },
            previous: function () { return menu.previous(); },
            selectFocusedItem: function () { return menu.selectFocusedItem(); },
            selection: function () { return __spreadArray([], selection, true); },
        };
    });
    //#endregion
    //#region Internal Functions
    /** Normalize incoming data to internal WrappedData<T,M> format */
    var wrapData = function () {
        var outerGroup = new models_1.Grouping("", incomingData || []);
        var wrapped = outerGroup.map(function (item) {
            return (0, SelectionMenu_models_1.isDatumWithMetadata)(item) ? item : [item, {}];
        });
        setWrappedData(wrapped);
        return wrapped;
    };
    /** Update group metadata for radio/checkbox selection behavior (relies on Grouping's depth-first behavior) */
    var updateMetadata = function () {
        if (!wrappedData) {
            return;
        }
        wrappedData.forEach(undefined, function (group) {
            var activeChildren = false;
            var inactiveChildren = false;
            for (var _i = 0, _a = group.children; _i < _a.length; _i++) {
                var child = _a[_i];
                if (child instanceof models_1.Grouping) {
                    activeChildren = Boolean(activeChildren ||
                        child.metadata.active ||
                        child.metadata.indeterminate);
                    inactiveChildren = Boolean(inactiveChildren ||
                        !child.metadata.active ||
                        child.metadata.indeterminate);
                }
                else {
                    activeChildren = Boolean(activeChildren || selection.includes(child[0]));
                    inactiveChildren = Boolean(inactiveChildren || !selection.includes(child[0]));
                }
                if (activeChildren && inactiveChildren) {
                    break;
                }
            }
            group.metadata.active = activeChildren && !inactiveChildren;
            group.metadata.indeterminate = activeChildren && inactiveChildren;
        });
    };
    /**
     * Set up selection state from prop, falling back on item metadata if not provided
     */
    var initializeSelection = function (wrapped) {
        // if selection provided, use it (even if it has been completely emptied)
        if (incomingSelection) {
            setSelection(incomingSelection);
            // otherwise, use incoming item metadata to initialize selection
        }
        else {
            var initiallyActive = wrapped.filter(function (item) { return Boolean(item[1].active); });
            if (initiallyActive && initiallyActive.children.length) {
                var newSel = initiallyActive.flatten().map(function (i) { return i[0]; });
                setSelection(newSel);
            }
        }
    };
    /** Construct menu items from wrapped data and selection */
    var buildMenuItems = function () {
        var itemsToWrap = filterable
            ? new models_1.Grouping("", filteredItems)
            : wrappedData;
        if (!itemsToWrap) {
            return;
        }
        var items = itemsToWrap.mapChildren(function (_a, treePos) {
            var _b = _a, item = _b[0], _c = _b[1], selectable = _c.selectable, onSelect = _c.onSelect, itemProps = __rest(_c, ["selectable", "onSelect"]);
            var merged = Object.assign({}, { "data-qa": menuQAProp ? menuQAProp + "--item" : undefined }, itemProps);
            return (React.createElement(components_1.GKMenuItem, __assign({ key: "selection-menu" + treePos.join("-") }, merged, { active: selection.find(function (sel) { return (0, react_fast_compare_1.default)(sel, item); }) !== undefined
                    ? true
                    : false, onSelect: function () {
                    if (selectable !== false) {
                        toggleSelected(item);
                    }
                    return onSelect && onSelect(item);
                } }), itemTemplate &&
                itemTemplate(item, __assign(__assign({}, itemProps), { selectable: selectable, active: selection.includes(item) }))));
        }, function (groupName, children, meta, treePos) {
            // Intentionally destructured from pasthroughProps
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var active = meta.active, isLoading = meta.isLoading, indeterminate = meta.indeterminate, pasthroughProps = __rest(meta, ["active", "isLoading", "indeterminate"]);
            var merged = Object.assign({}, { "data-qa": menuQAProp ? menuQAProp + "--group" : undefined }, pasthroughProps);
            return (React.createElement(components_1.GKMenuGroup, __assign({}, merged, { isLoading: isLoading, key: "selection-menu-group" + treePos.join("-"), 
                // get group from label. wrappedData will always contain the group, hence the any cast.
                // TODO: implement a version of map that has the group itself...
                label: groupTemplate &&
                    groupTemplate(itemsToWrap.findGroup(function (g) { return g.groupName === groupName; })[0]), onSelect: selectMultiple && groupSelection ? groupSelect : undefined, payload: groupName }), children));
        });
        setMenuItems(items);
    };
    /** Handler for menu item selection event */
    var toggleSelected = function (changed) {
        if (!wrappedData) {
            return;
        }
        var selectionSet = new Set(selection);
        // Multiple selection
        if (selectMultiple) {
            if (selectionSet.has(changed)) {
                selectionSet.delete(changed);
            }
            else {
                selectionSet.add(changed);
            }
            // Multiple selection && radio-style group selection
            if (groupSelection === "single") {
                var _a = wrappedData.findItem(function (_a) {
                    var item = _a[0];
                    return item === changed;
                }), tpos = _a[1];
                if (tpos) {
                    turnOffOtherGroups(tpos, selectionSet);
                }
            }
            // Single selection
        }
        else {
            selectionSet.clear();
            if (!selectionSet.has(changed)) {
                selectionSet.add(changed);
            }
        }
        setAndNotifySelection(Array.from(selectionSet));
    };
    /** Handler for group selection event */
    var groupSelect = function (groupName, isTarget) {
        if (!wrappedData) {
            return;
        }
        // only respond to direct selections (not bubbled events), only relevant if multiple selection enabled
        if (!isTarget && selectMultiple) {
            return;
        }
        // short-circuit if group doesn't exist
        var _a = wrappedData.findGroup(function (g) { return g.groupName === groupName; }), group = _a[0], treePos = _a[1];
        if (!group || !treePos) {
            return;
        }
        var targetActivity = !group.metadata.active;
        var selectionSet = new Set(selection);
        // checkbox-style selection - turn on/off all decendants
        if (groupSelection === "multi") {
            group.forEach(function (_a) {
                var item = _a[0];
                return targetActivity ? selectionSet.add(item) : selectionSet.delete(item);
            }, function (g) {
                g.metadata.active = targetActivity;
                g.metadata.indeterminate = false;
            });
            // radio-style selection - turn on all non-group children, recursively turn on all first-group decendants,
            // turn off all other items at this level of the tree and down.
        }
        else if (groupSelection === "single") {
            var recurseDownFirstGroup_1 = function (gp) {
                var firstGroupEncountered = false;
                gp.children.forEach(function (child) {
                    if (child instanceof models_1.Grouping) {
                        if (firstGroupEncountered) {
                            child.forEach(function (_a) {
                                var item = _a[0];
                                return selectionSet.delete(item);
                            }, function (g) { return (g.metadata.active = g.metadata.indeterminate = false); });
                        }
                        else {
                            firstGroupEncountered = true;
                            recurseDownFirstGroup_1(child);
                        }
                    }
                    else {
                        selectionSet.add(child[0]);
                    }
                });
            };
            recurseDownFirstGroup_1(group);
            turnOffOtherGroups(treePos, selectionSet);
        }
        setAndNotifySelection(Array.from(selectionSet));
    };
    /**
     * Given a tree position and under-construction selection, remove anything which isn't a member of the
     * direct heirarchy. E.g. given a tpos 1.2.3, 1.2 would be unaffected, but 1.2.4 would be turned off.
     */
    var turnOffOtherGroups = function (tpos, selectionSet) {
        if (!wrappedData) {
            return;
        }
        wrappedData.forEach(function (_a, ipos) {
            var item = _a[0];
            var parent = ipos.slice(0, ipos.length - 1);
            for (var i = 0; i < tpos.length && i < parent.length; i++) {
                if (tpos[i] !== parent[i]) {
                    selectionSet.delete(item);
                    return;
                }
            }
        });
    };
    var setAndNotifySelection = function (sel) {
        setSelection(sel);
        if (onChange) {
            onChange(sel);
        }
    };
    /**
     * If there is an active menu item, scroll to it.
     * setTimeout is required because the menu doesn't immediately exist on open
     */
    var scrollToSelected = function () {
        window.setTimeout(function () {
            var _a, _b;
            var menu = document.querySelector("#" + ((_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.uniqueId));
            var active = menu === null || menu === void 0 ? void 0 : menu.querySelector(".gk-menu-item.active");
            (_b = active === null || active === void 0 ? void 0 : active.scrollIntoView) === null || _b === void 0 ? void 0 : _b.call(active, { block: "start" });
        }, 10);
    };
    //#endregion
    //#region Effects
    React.useEffect(function () {
        var wrapped = wrapData();
        initializeSelection(wrapped);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [incomingData, selectMultiple, groupSelection]);
    React.useEffect(function () {
        if (wrappedData) {
            setSelection((incomingSelection !== undefined
                ? incomingSelection
                : []));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [incomingSelection]);
    React.useEffect(function () {
        onMenuToggle === null || onMenuToggle === void 0 ? void 0 : onMenuToggle(isOpen);
    }, [isOpen]);
    React.useEffect(function () {
        updateMetadata();
        buildMenuItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selection, wrappedData, filterable, filteredItems, onChange]);
    //#endregion
    //#region Render
    return (React.createElement(components_1.GKMenu, __assign({ isOpen: isOpen }, (0, common_1.mapDefaultProps)(otherProps, {
        _gkComponentName: "gk-selection-menu",
        "data-qa": menuQAProp,
    }), { ref: menuRef, onOpen: scrollToSelected }),
        filterable && (React.createElement(components_1.GKMenuHeader, null,
            React.createElement(components_1.DataFilter, { data: wrappedData ? wrappedData.children : [], filterFunction: filterFunction, onFilter: function (filtered) { return setFilteredItems(filtered); } }))),
        !filterable && headerTemplate && (React.createElement(components_1.GKMenuHeader, null, headerTemplate())),
        (menuItems.length && menuItems) || (React.createElement(components_1.GKMenuItem, { disabled: true }, emptyTemplate && emptyTemplate())),
        footerTemplate && React.createElement(components_1.GKMenuFooter, null, footerTemplate())));
    //#endregion
};
/**
 * Selection Menu Component - Provides a wrapper for GKMenu which adds selection behavior. Only
 * accepts data properties, not children.
 *
 * @remarks
 * Supports both single and multiple selection as well as checkbox-style (hierarchical/tree)
 * and radio-style (only one group selected per level of grouping). Does not enforce any opinons
 * regarding focus or other menu behavior, leaving such decisions to the consumer via pass-
 * through props.
 *
 * @internal
 */
exports.GKSelectionMenu = React.forwardRef(SelectionMenuDefinition);
exports.default = exports.GKSelectionMenu;
